export default __webpack_public_path__ + "static/media/Solemate.4c668051.png";